import React, { useEffect, useContext } from 'react';
import { useParams, useHistory } from 'react-router-dom';

import {
    LinearProgress,
    Grid,
    Container
} from '@material-ui/core';

import {
    PageHeader
} from '../../../common';

import {
    UserDetails,
    UserTables
} from './components';

import { PageProvider, PageContext } from './PageContext';
import { NavContext, NavRoutes } from '../../../contexts';

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {
    },
    container: {
        marginTop: theme.spacing(2)
    }
}));

const PageContent = (props) => {
    const classes = useStyles();

    const {
        state,
        pageIsReady,
        setPageIsReady,
        isBusy,
        setIsBusy,
        getUserAsync,
        getRolesAsync,
        getTablesAsync,
        addRoleToUserAsync,
        removeRoleForUserAsync
    } = useContext(PageContext);

    const {
        navigateTo,
        switchTo
    } = useContext(NavContext);

    const {
        user,
        roles,
        tables
    } = state;

    const viewOtherRoleHandler = (role) => {
        switchTo(NavRoutes.Admin.Role, [role.roleId]);
    }

    const loadMoreHandler = async (searchText, pageIndex, pageSize) => {
        setIsBusy({ loadMore: true });
        await getTablesAsync(searchText, pageIndex, pageSize);
        setIsBusy({ loadMore: false });
    }

    const toggleTableHandler = async (role, user, table) => {
        setIsBusy({ toggleTable: true });
        if (user.tables.findIndex(x => x.tableId === table.managedTableId
            && x.roleIds.find(r => r === role.applicationRoleId)) === -1) {
            await addRoleToUserAsync({
                roleId: role.applicationRoleId,
                userId: user.userId,
                tableId: table.managedTableId
            });
        } else {
            await removeRoleForUserAsync(
                role.applicationRoleId,
                user.userId,
                table.managedTableId
            );
        }
        setIsBusy({ toggleTable: false });
    }

    const { roleId, userId } = useParams();
    useEffect(() => {
        if (userId) {
            getUserAsync(userId);
            getRolesAsync();
            getTablesAsync(null, 0, 20);
        }
    }, [userId]);

    useEffect(() => {
        if (tables) {
            setPageIsReady(user !== null
                && roles !== null
                && tables !== null);
        }
    }, [user, roles, tables]);

    return (
        <>
            {pageIsReady ?
                <Grid container spacing={3} className={classes.root}>
                    <Grid item xs={12}>
                        <PageHeader
                            title={user.displayName}
                            subtitle="User details"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Container maxWidth="lg" className={classes.container}>
                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <UserDetails
                                        disabled={isBusy()}
                                        onViewOtherRole={viewOtherRoleHandler}
                                    />
                                </Grid>
                                {user.isManagement &&
                                    <Grid item xs={12}>
                                        <UserTables
                                            itemsPerPage={20}
                                            loading={isBusy("loadMore")}
                                            disabled={isBusy()}
                                            onLoadMore={loadMoreHandler}
                                            onToggleTable={toggleTableHandler}
                                        />
                                    </Grid>
                                }
                            </Grid>
                        </Container>
                    </Grid>
                </Grid>
                :
                <LinearProgress />
            }
        </>
    );
}

export const RoleUserPage = () => {

    return (
        <PageProvider>
            <PageContent />
        </PageProvider>
    );
}